module.exports = [
    { label: 'Square Foot Range', id: 'sqft', values: ['500','600','700','800','900','1000+']},
    { label: '# of Bedrooms', id: 'numOfBeds', values: ['1','2','3']},
    { label: '# of Baths', id: 'numOfBaths', values: ['1','2']},
];